import React from 'react';
import ToastItem from './ToastItem.jsx';
import '../../styles/toast.css';

/**
 * 画面下部に固定。ルート遷移後も ToastProvider 内で表示を維持する。
 */
const ToastViewport = ({ toasts, onDismiss }) => {
  if (toasts.length === 0) return null;

  return (
    <div className="hub-toast-viewport" aria-live="polite" aria-relevant="additions">
      {toasts.map((toast) => (
        <ToastItem
          key={toast.id}
          toast={toast}
          onDismiss={() => onDismiss(toast.id)}
        />
      ))}
    </div>
  );
};

export default ToastViewport;
